import { Link, type LinkProps } from 'react-router-dom'
import { useLocalizedHref } from './useLocalizedHref'

/**
 * Drop-in `<Link>` that prefixes string `to` targets with the active locale.
 * Object `to` values pass through unchanged.
 */
export function LocaleLink({ to, ...rest }: LinkProps) {
  const localized = useLocalizedHref()
  return <Link to={typeof to === 'string' ? localized(to) : to} {...rest} />
}
